/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { useOktaAuth } from '@okta/okta-react';
import { useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';

const Authenticate = ({ username }) => {
  const { authState, oktaAuth } = useOktaAuth();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userHint = queryParams.get('username') || username;

  const login = async () => {
    oktaAuth.signInWithRedirect(
      {
        originalUri: '/authenticate',
        loginHint: userHint,
      },
    );
  };

  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      login();
    } else {
      window.location.href = 'https://oktane22oie.ct50.cvent-conference-intg.cvent.cloud/'
      + 'portal/v2/login'
      + '?stateToken=eyJhbGciOiJIUzI1NiJ9.eyJtb2R1bGUiOiJwb3J0YWwiLCJwYWdlIjoibXlBY2NvdW50Lnd3In0.LxX7xBM9dHAMGeIQ4PoOsN8GWwruioHEh7XorASY9kk&autoRedirectToIDP=true';
    }
  }, [authState, oktaAuth]);

  if (!authState) {
    return (
      <div>Loading...</div>
    );
  }

  return <></>;
};

export default Authenticate;
